<template>
    <q-dialog v-model="showModal">
        <q-card style="width: 700px; max-width: 80vw;">
            <q-card-section>
                <slot name="header">
                    <div class="text-h6"><q-icon name="fa fa-file-invoice" color="Primary" size="20px"/> Receipts</div>
                </slot>
            </q-card-section>

            <q-separator/>

            <q-card-section>
                <q-inner-loading style="z-index: 999" :showing="loading">
                    <q-spinner-dots size="100px" color="primary"/>
                </q-inner-loading>
                <q-table
                    ref="table"
                    :data="serverData"
                    :columns="columns"
                    row-key="name"
                    :filter="filter"
                    :loading="loading"
                    @request="all"
                    :pagination="initialPagination"
                    hide-pagination
                >
                    <template v-slot:top-right="props">
                        <q-btn
                            outline
                            :label="$t('upload')"
                            icon="fas fa-file-arrow-up"
                            color="primary"
                            class="q-mr-sm"
                            @click="$emit('upload')"
                            v-if="showUploadButton"
                        />
                    </template>

                    <!-- START CUSTOM COLUMNS -->
                    <q-td slot="body-cell-setting" slot-scope="props" :props="props" v-if="$auth.can('transfers.edit')">
                        <q-btn flat round size="md" color="primary" icon="fas fa-file-arrow-down" @click="download(props.row)" :loading="downloading || loading" />&nbsp;
                    </q-td>
                    <!-- END CUSTOM COLUMNS -->
                </q-table>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat label="Back" color="primary" v-close-popup/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import Transfer from "../models/Transfer"
export default {
    name: "ReceiptsDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        reference: {
            type: String,
            required: true
        },
        transactionId: {
            type: Number,
            default: 0
        },
        showUploadButton: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        columns() {
            return [
                {name: 'setting', align: 'left', label: this.$t('transfers.ift_table_titles.actions'), sortable: false, field: 'setting'},
                {name: 'name', label: 'File name', align: 'left', field: 'name', sortable: true},
            ]
        },
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            serverData: [],
            separator: 'horizontal',
            filter: '',
            loading: false,
            downloading: false,
            initialPagination: {
                sortBy: 'name',
                descending: true,
                page: 1,
                rowsPerPage: 99
            },
        }
    },
    methods: {
        all() {
            this.loading = true
            new Transfer({
                reference: this.reference,
                transaction_id: this.transactionId
            }).receipts((data) => {
                this.loading = false
                this.serverData = data
            }).catch(error  => {
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.loading = false
            })
        },
        download(row) {
            this.downloading = true
            new Transfer({reference: this.reference, file_name: row.name}, null, 'blob').downloadReceipt((response) => {
                this.$download(response, row.name)

                this.downloading = false
            }).catch(error => {
                this.$q.notify({
                    message: 'There is an issue in downloading the file.',
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.downloading = false
            })
        },
        deleteFile(row) {
            this.$q.dialog({
                title: 'Delete the file',
                message: 'Are your sure?',
                ok: 'Yes',
                cancel: 'No'
            }).onOk(() => {
                this.$q.loading.show()
                new Ift({name: row.name}).destroy(() => {
                    this.serverData = this.serverData.filter(record => record.name !== row.name);
                    this.$q.loading.hide()
                }).catch(({data}) => {
                    this.$q.notify(data.error)
                    this.$q.loading.hide()
                })
            }).onCancel(() => {
                this.$q.loading.hide()
            })
        }
    },
    created() {
    },
    mounted() {},
    watch: {
        showModal(val) {
            if (val) {
                this.all()
            }
        }
    },
    components: {},
}
</script>
<style>

</style>
